<template>
    <div>
        <div class="mt-4" style="display: flex; justify-content: space-between;">
            <template v-for="(step, index) in steps">
                <div>
                    <CButton
                        :class="{ 'step-button-active': progressValue >= step.threshold, 'step-button': progressValue < step.threshold }">
                        <i :class="step.icon"></i>
                    </CButton>
                </div>
                <div v-if="index < steps.length - 1" style="width: 100%;" class="pt-3 pl-1 pr-1">
                    <CProgress color="success" variant="striped" animated :value="progressBar[index]" />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { CButton, CProgress } from '@coreui/vue';
import '@/util/delivery.css'

export default {
    components: {
        CButton,
        CProgress
    },
    props: {
        stepNum: {
            type: Number,
            required: true
        },
        icons: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            progressValue: 100 / this.stepNum, // Initial progressValue set to the threshold of the first step
            progressBar: []
        }
    },
    computed: {
        steps() {
            const thresholds = Array.from({ length: this.stepNum }, (_, i) => (i + 1) * (100 / this.stepNum));
            return thresholds.map((threshold, index) => ({
                threshold,
                icon: this.icons[index] || 'fi fi-rr-question'
            }));
        }
    },
    watch: {
        progressValue() {
            this.setProgressbar();
        }
    },
    mounted() {
        this.setProgressbar();
    },
    methods: {
        setProgressbar() {
            this.progressBar = this.steps.map(step => this.progressValue > step.threshold ? 100 : 0);
        },
        setProgressStep(stepNumber) {
            if (stepNumber > this.stepNum || stepNumber < 1) return;
            this.progressValue = stepNumber * (100 / this.stepNum);
        }
    }
}
</script>
<style>
.stepbar {
    width: 100%;
}

.progress {
    height: 8px;
}

.step-button {
    font-size: large;
    width: 40px;
    height: 40px;
    z-index: 1020;
    background-color: #eeeeee;
    border: none;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 1.5cap;

}

.step-button-active {
    padding-top: 1.5cap;
    padding-left: 0px;
    padding-right: 0px;
    font-size: large;
    width: 40px;
    height: 40px;
    z-index: 1020;
    border-radius: 50%;
    color: #fff;
    background-color: var(--bg-color-theme);
    border: none;
}

.bg-success {
    background-color: var(--bg-color-theme) !important;
}
</style>
